module.exports = "/assets/488cdc3ba4b064335f35649254d45b80.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/KE.png
// module id = 2666
// module chunks = 0